// extracted by mini-css-extract-plugin
module.exports = {"loginForm":"LoginForm_loginForm__2rOp2"};